import type { EmailDeliveryPolicy, WebhookDeliveryPolicy } from "@fmc/contracts";

export type DestinationType = "webhook" | "email";

export interface Destination {
  id: string;
  name: string;
  type: DestinationType;
  target: string;
  events: string;
  active: boolean;
  verified?: boolean;
  paused?: boolean;
  lastDelivery: string;
  failures: number;
  queued?: number;
  deliveryPolicy?: EmailDeliveryPolicy | WebhookDeliveryPolicy;
}

export const typeMeta: Record<DestinationType, { label: string; icon: string; hint: string }> = {
  webhook: {
    label: "Webhook",
    icon: "fa-arrow-up-right-from-square",
    hint: "POST a JSON payload to a URL you control.",
  },
  email: {
    label: "Email",
    icon: "fa-envelope",
    hint: "Send a formatted email the moment a lead arrives. Delivered via Resend.",
  },
};
